import Base from './Base';
import { Post, createPosts } from './Post';

export default Base.create();
export {
  Base,
  Post,
  createPosts,
};



// WEBPACK FOOTER //
// ./components/Intranet/News/index.js